/* esm.sh - applesauce-signers@5.2.0/signers/serial-port-signer */
export * from "/*applesauce-signers@5.2.0/esnext/signers/serial-port-signer.mjs";
